module.exports = __webpack_public_path__ + "img/logo-tosca.33e24ea1.png";